import * as Styled from './SomethingWentWrong.styles';
import { resources } from 'oems/resources';

export default function SomethingWentWrong() {
  return (
    <Styled.Wrapper>
      <Styled.LeftDescription>
        <img src={resources.logoDarkImage} alt="logo" className="logo" />
        <Styled.Content>
          <Styled.Title>Coś poszło nie tak</Styled.Title>
          Przepraszamy, ale wystąpił błąd. Spróbuj ponownie później.
        </Styled.Content>
      </Styled.LeftDescription>
      <Styled.RightDescription></Styled.RightDescription>
    </Styled.Wrapper>
  );
}
